import { createSlice } from "@reduxjs/toolkit";

const Productslice = createSlice({
    name : "product",
    initialState : {
        loading : false,
        product : []
    },
    reducers:{
        productrequest : (state,action)=>{
            state.loading = true
            console.log(state.loading)

        },
        productsuccess : (state,action)=>{
            state.loading = false
            state.product = action.payload
            console.log(state.loading)
            // console.log(state.product[0].desc)
            console.log(state.product)
            
        },
        productfail : (state,action) =>{
            state.loading = false

        }
    }
})
export default Productslice;